module.exports = __webpack_public_path__ + "odstraneni-tetovaze_1_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/odstraneni-tetovaze_1_before.jpg
// module id = 954
// module chunks = 0